import type { Event } from '@bugsnag/js'

const TOKEN_PARAM = /([?&](?:login_token|reset_password_token|token)=)[\w.~%-]+/gi

export const redactTokens = (value: string): string => value.replace(TOKEN_PARAM, '$1[REDACTED]')

export const redactBugsnagEvent = (event: Event): void => {
  if (event.request.url) event.request.url = redactTokens(event.request.url)
  if (event.context) event.context = redactTokens(event.context)
  event.errors.forEach((error) => {
    error.errorMessage = redactTokens(error.errorMessage)
  })
  event.breadcrumbs.forEach((breadcrumb) => {
    breadcrumb.message = redactTokens(breadcrumb.message)
    Object.entries(breadcrumb.metadata).forEach(([key, value]) => {
      if (typeof value === 'string') breadcrumb.metadata[key] = redactTokens(value)
    })
  })
}
